import React from 'react';
import mansalva from '../../images/Mansalva/Mansalva-Regular.ttf';

const NativeAppHeader = () => {
  // Header temporarily hidden
  return null;
};

export default NativeAppHeader;